import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Necesito mostrar mis papeles para empezar?',
  answer: 'El marketing de afiliados se basan en resultados. Puedes empezar a aprender y construir hoy mismo de forma privada.'
}, {
  question: '¿Es difícil aprender si no sé de tecnología?',
  answer: 'No. Tenemos explicaciones claras y recursos accionables diseñados para que cualquiera pueda seguirlos.'
}, {
  question: '¿Realmente puedo ganar dinero sin que nadie me vea?',
  answer: 'Sí. El 90% de los grandes afiliados del mundo operan bajo seudónimos o marcas comerciales, nunca muestran su cara.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-[#0a0a0a] py-24 border-t border-white/5" data-id="element-14">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-17">
            Preguntas frecuentes
          </h2>
          <div className="w-24 h-1 bg-[#d4a437] mx-auto rounded-full opacity-50" data-id="element-18"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-19">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-[#111] border border-white/10 rounded-xl overflow-hidden" data-id="element-20">
              <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-[#d4a437]" aria-expanded={openIndex === index} data-id="element-21">
                <span className="text-lg font-medium text-white pr-4" data-id="element-22">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} className="flex-shrink-0 text-[#d4a437]" data-id="element-23">
                  <ChevronDown className="w-5 h-5" data-id="element-24" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-25">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-26">
                    <div className="px-6 pb-5 text-neutral-400 leading-relaxed border-t border-white/5 pt-4" data-id="element-27">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}